import {GET_WEATHER_HISTORY_SUCCESS} from "../../reducers/weatherReducer";

export const getWeatherHistorySuccess = (weatherHistory) =>{
    return {
        type: GET_WEATHER_HISTORY_SUCCESS,
        payload: {weatherHistory}
    }
}